import React, { Component } from 'react';
import { FingerprintPattern } from 'lucide-react';
import { GeckoBtn } from '../../../../../../components';
import { APP_CONST } from '../../../../../../constants';

export class Unconfigured extends Component {
    render() {
        return (
            <div>
                <p className="text-sm font-medium text-foreground mb-4">Two factor authentication is not set up.</p>
                <GeckoBtn
                    name="Enable two factor authentication"
                    icon={FingerprintPattern}
                    type={APP_CONST.BTN_TYPE_PRIMARY}
                    className="self-start"
                    handler={this.props.onClick}
                />
            </div>
        )
    }
}

Unconfigured.defaultProps = {
    onClick: () => {},
}

export default Unconfigured;